import React from 'react';
import { Tables } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';
import GroupIcon from '@material-ui/icons/Group';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import Tooltip from '@material-ui/core/Tooltip';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { GroupType } from 'pages/OrganizationAdmin/types';
import { Pill } from '../Users/User';

const { TableRow, TableCell } = Tables;

interface Props extends RouteComponentProps {
  name: string;
  id: number;
  sharedGroups: GroupType[];
  workbench: string;
}

const Product = ({ name, workbench, history, id, sharedGroups }: Props) => {
  const t = useFormatMessage();

  return (
    <TableRow>
      <TableCell height="2rem" padding="0.5rem">
        {name}
      </TableCell>
      <TableCell height="2rem" padding="0.5rem">
        {workbench}
      </TableCell>

      <TableCell height="2rem" padding="0.5rem">
        {sharedGroups.map((group) => {
          return <Pill key={group.name}>{group.name}</Pill>;
        })}
      </TableCell>
      <TableCell height="2rem" padding="0.5rem">
        <Tooltip title={t('organization.users', 'Users')}>
          <GroupIcon
            style={{ cursor: 'pointer', margin: '0 2px' }}
            onClick={() =>
              history.push(`/organization/products/${id}/shared?tab=users`)
            }
          />
        </Tooltip>
        <Tooltip title={t('organization.groups', 'Groups')}>
          <RecentActorsIcon
            style={{ cursor: 'pointer', margin: '0 2px' }}
            onClick={() =>
              history.push(`/organization/products/${id}/shared?tab=projects`)
            }
          />
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default withRouter(Product);
